"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.string.small");

var _isNumber2 = _interopRequireDefault(require("lodash/isNumber"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));

var _view = _interopRequireDefault(require("./view"));

var _boxModule = _interopRequireDefault(require("./box.module.less"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// Default styles and properties
var defaultBoxStyles = {
  columns: 'auto',
  direction: 'row',
  display: 'flex',
  hasOuterMargin: false,
  noGutter: null,
  justify: 'flex-start',
  wrap: 'wrap'
};
/**
 * Generate styles based on the Grid System constraints
 * around breakpoint sizes.
 */

var getBoxStyles = function getBoxStyles(breakpoint, _ref) {
  var columns = _ref.columns,
      direction = _ref.direction,
      hasOuterMargin = _ref.hasOuterMargin,
      noGutter = _ref.noGutter,
      justify = _ref.justify,
      wrap = _ref.wrap;
  var boxStyles = [(0, _classnames.default)((0, _classes.default)(['display-flex']), _boxModule.default["col-".concat(columns, "-").concat(breakpoint)], _boxModule.default["flex-direction-".concat(direction || defaultBoxStyles.direction, "-").concat(breakpoint)], _boxModule.default["no-gutter-".concat(noGutter, "-").concat(breakpoint)], _boxModule.default["justify-content-".concat(justify || defaultBoxStyles.justify, "-").concat(breakpoint)], _boxModule.default["flex-wrap-".concat(wrap || defaultBoxStyles.wrap, "-").concat(breakpoint)], hasOuterMargin ? _boxModule.default['outer-margin'] : null)]; // Only apply gutters if the column size has been modified from default. This
  // allows containing Boxes to not have any gutters

  if ((0, _isNumber2.default)(columns)) {
    if (noGutter === 'left' || noGutter === 'right' || noGutter === 'both') {
      boxStyles.push(_boxModule.default["no-gutter-".concat(noGutter, "-").concat(breakpoint)]);
    } else {
      boxStyles.push(_boxModule.default["gutter-".concat(breakpoint)]);
    }
  }

  return boxStyles;
};
/**
 * Atomic alignment component. Internally knows about the NDS breakpoint. Used
 * to implement component and page level layout around a consistent grid system.
 */


var Box = function Box(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      isReactNative = _ref2.isReactNative,
      small = _ref2.small,
      wide = _ref2.wide,
      props = _objectWithoutProperties(_ref2, ["children", "className", "isReactNative", "small", "wide"]);

  // Apply Grid System styles as well as custom styles
  var smallStyles = getBoxStyles('small', small);
  var wideStyles = getBoxStyles('wide', wide);
  var gridStyles = (0, _classnames.default)(smallStyles, wideStyles, className); // Mount the react-native View if flag is provided

  if (isReactNative) {
    return _react.default.createElement(_view.default, props);
  }

  return _react.default.createElement("div", _extends({
    className: gridStyles
  }, props), children);
};

Box.propTypes = {
  /*
   * Child element that will Box will compose.
   */
  children: _propTypes.default.node,

  /*
   * base-styles classes (or custom if needed) applied directly to the flexbox item.
   */
  className: _propTypes.default.string,

  /**
   * Boolean flag to indicate if a stylesheet should be created for React Native.
   */
  isReactNative: _propTypes.default.bool,
  small: _propTypes.default.shape({
    /**
     * Remove the horizontal padding around the left, right, or both sides of Box. Intended
     * to be used on the outer columns of the Grid (reason for the name of the prop).
     */
    noGutter: _propTypes.default.oneOf(['left', 'right', 'both']),

    /**
     * Align items (symmetric to flexbox) along the cross-axis.
     */
    direction: _propTypes.default.string,

    /**
     * Flag used to indicate if the box needs the outer margin to be applied.
     * spacing-3 on smaller breakpoints, spacing-5 on larger.
     */
    hasOuterMargin: _propTypes.default.bool,

    /**
     * Arrange the boxes based on cross and main axis within the smaller breakpoint. Behaves like the
     * justify-content CSS property and supports the standard.
     */
    justify: _propTypes.default.oneOf(['center', 'flex-end', 'flex-start', 'space-around', 'space-between', 'space-evenly', 'start']),

    /**
     * Number to indicate how many columns to fill
     * the flex container in the smaller (<= 767) breakpoint. If this is set with
     * a prop other than the default, we apply display-flex.
     */
    columns: _propTypes.default.oneOf(['auto', 0, 1, 2, 3, 4]),

    /**
     * Flag to indicate if flexbox items should wrap or nowrap. Default is wrap.
     */
    wrap: _propTypes.default.oneOf(['wrap', 'nowrap'])
  }),

  /**
   * Number to indicate how many columns to fill
   * the flex container in the larger (>=768) breakpoint. If this is set with
   * a prop other than the default, we apply display-flex.
   */
  wide: _propTypes.default.shape({
    /**
     * Remove the horizontal padding around the left, right, or both sides of Box. Intended
     * to be used on the outer columns of the Grid (reason for the name of the prop).
     */
    noGutter: _propTypes.default.oneOf(['left', 'right', 'both']),

    /**
     * Align items (symmetric to flexbox) along the cross-axis.
     */
    direction: _propTypes.default.string,

    /**
     * Flag used to indicate if the box needs the outer margin to be applied.
     * spacing-3 on smaller breakpoints, spacing-5 on larger.
     */
    hasOuterMargin: _propTypes.default.bool,

    /**
     * Arrange the boxes based on cross and main axis within the smaller breakpoint. Behaves like the
     * justify-content CSS property and supports the standard.
     */
    justify: _propTypes.default.oneOf(['center', 'flex-end', 'flex-start', 'space-around', 'space-between', 'space-evenly', 'start']),

    /**
     * Number to indicate how many columns to fill
     * the flex container in the wider (>= 768) breakpoint. If this is set with
     * a prop other than the default, we apply display-flex.
     */
    columns: _propTypes.default.oneOf(['auto', 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

    /**
     * Flag to indicate if flexbox items should wrap or nowrap. Default is wrap.
     */
    wrap: _propTypes.default.oneOf(['wrap', 'nowrap'])
  })
};
Box.defaultProps = {
  children: null,
  className: null,
  isReactNative: false,
  small: defaultBoxStyles,
  wide: defaultBoxStyles
};
var _default = Box;
exports.default = _default;